import { io } from "socket.io-client";
import { useEffect, useRef, createContext, useContext } from "react";

const SocketContext = createContext(null);

export function SocketProvider({ children, token }) {
    const socketRef = useRef(null);

    useEffect(() => {
        if (!token) return;

        const socket = io(process.env.REACT_APP_BASE_API_WS, {
            transports: ["websocket"],
            auth: { token },
        });

        socketRef.current = socket;

        socket.on("connect_error", (err) => {
            if (err.message === "unauthorized") {
                // TODO: refresh token si besoin
            }
        });

        return () => {
            socket.disconnect();
            socketRef.current = null;
        };
    }, [token]);

    return (
        <SocketContext.Provider value={socketRef}>
            {children}
        </SocketContext.Provider>
    );
}

export function useSocket() {
    return useContext(SocketContext);
}
